<template>
  <div class="form-item-render">
    <!-- 自定义组件类型 -->
    <template v-if="field.type === 'Component'">
      <div v-if="showLabel" class="component-label">
        <span v-if="required" class="required-mark">*</span>
        {{ field.title }}
      </div>
      <component
        :is="getComponent(field.component)"
        :value="value"
        :readonly="readonly"
        :flow-inc="flowInc"
        :form-data="formData"
        :logs="logs"
        @input="handleInput"
      />
    </template>

    <!-- 普通表单项 -->
    <el-form-item
      v-else
      :label="field.title"
      :required="required"
      :prop="prop"
    >
      <!-- 多行文本 -->
      <el-input
        v-if="field.inputType === 'textarea'"
        :value="value"
        type="textarea"
        :rows="3"
        :disabled="readonly"
        :placeholder="field.desc || '请输入'"
        @input="handleInput"
      />

      <!-- 下拉选择 -->
      <el-select
        v-else-if="field.inputType === 'select'"
        :value="value"
        :disabled="readonly"
        style="width: 100%;"
        :placeholder="field.desc || '请选择'"
        @input="handleInput"
      >
        <el-option
          v-for="opt in getOptions(field.inputTypeList)"
          :key="opt"
          :label="opt"
          :value="opt"
        />
      </el-select>

      <!-- 开关 -->
      <el-switch
        v-else-if="field.inputType === 'switch'"
        :value="value"
        :disabled="readonly"
        @input="handleInput"
      />

      <!-- 数字 -->
      <el-input-number
        v-else-if="field.inputType === 'number'"
        :value="value"
        :disabled="readonly"
        @input="handleInput"
      />

      <!-- 日期/时间 -->
      <el-date-picker
        v-else-if="field.inputType === 'date' || field.inputType === 'datetime'"
        :value="value"
        :type="field.inputType"
        :disabled="readonly"
        style="width: 100%;"
        :placeholder="field.desc || '请选择'"
        @input="handleInput"
      />

      <!-- 默认单行文本 -->
      <el-input
        v-else
        :value="value"
        :disabled="readonly"
        :placeholder="field.desc || '请输入'"
        @input="handleInput"
      />
    </el-form-item>
  </div>
</template>

<script>
import ApplicantInfo from './ApplicantInfo'
import SealSelector from './SealSelector'
import FlowLogs from './FlowLogs'
import TemplateFiles from './TemplateFiles'
import RiskControlOperator from './RiskControlOperator'

export default {
  name: 'FormItemRender',
  components: {
    ApplicantInfo,
    SealSelector,
    FlowLogs,
    TemplateFiles,
    RiskControlOperator
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    value: {
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    prop: {
      type: String,
      default: ''
    },
    flowInc: {
      type: Object,
      default: null
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    logs: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    showLabel() {
      // 某些组件自带标题，不需要外部显示 label
      // ApplicantInfo 自带 el-descriptions
      // FlowLogs 自带时间轴标题
      const noLabelComponents = ['ApplicantInfo', 'FlowLogs']
      return this.field.title && !noLabelComponents.includes(this.field.component)
    }
  },
  methods: {
    getComponent(name) {
      // 组件名映射，确保安全
      const map = {
        ApplicantInfo: 'ApplicantInfo',
        SealSelector: 'SealSelector',
        FlowLogs: 'FlowLogs',
        TemplateFiles: 'TemplateFiles',
        RiskControlOperator: 'RiskControlOperator'
      }
      return map[name] || 'div'
    },
    getOptions(listStr) {
      if (!listStr) return []
      return listStr.split(',').map(s => s.trim()).filter(s => s)
    },
    handleInput(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped>
.form-item-render {
  width: 100%;
}
.component-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
  font-weight: 700;
  line-height: 1.5;
}
.required-mark {
  color: #F56C6C;
  margin-right: 4px;
}
</style>
